import api from './client';

/**
 * Cases API calls (client-facing)
 */
export const casesAPI = {
  /**
   * Get all cases for current user
   */
  getCases: async () => {
    const response = await api.get('/api/cases/');
    return response.data;
  },

  /**
   * Get single case
   */
  getCaseById: async (id: number) => {
    const response = await api.get(`/api/cases/${id}/`);
    return response.data;
  },

  /**
   * Create new case
   */
  createCase: async (caseData: any) => {
    const response = await api.post('/api/cases/', caseData);
    return response.data;
  },

  /**
   * Update case
   */
  updateCase: async (id: number, caseData: any) => {
    const response = await api.put(`/api/cases/${id}/`, caseData);
    return response.data;
  },

  /**
   * Delete case
   */
  deleteCase: async (id: number) => {
    const response = await api.delete(`/api/cases/${id}/`);
    return response.data;
  },

  /**
   * Apply booking confirmation extraction to a case
   * Creates passengers and flight segments from user-validated extraction data
   */
  applyExtraction: async (caseId: number, extractionData: any) => {
    const response = await api.post(`/api/cases/${caseId}/apply-extraction/`, extractionData);
    return response.data;
  },
};
